import { render, staticRenderFns } from "./VersionHistory.pug?vue&type=template&id=193a769b&scoped=true&lang=pug&external"
import script from "./VersionHistory.js?vue&type=script&lang=js&external"
export * from "./VersionHistory.js?vue&type=script&lang=js&external"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=193a769b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a769b",
  null
  
)

export default component.exports